import { Card, Pagination, Space, Modal, Input, message, Button } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import MyDateSelector from '../../component/MyDateSelector';
import TableHeaderSection from '../../component/TableHeaderSection';
import baseuri from '../../methods/baseuri';
import { hideEmail } from '../../methods/utils/request-helpers';
import { MyEmptyTable } from '../../robots/email-robot/EmailRobot';
import { MyTableCard } from './UsersByCountry';
import UsersFilter from './UsersFilter';
import { MyTable } from './UsersList';

export const UsersListPage = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 1em;

	& .myCard {
		border-radius: 10px;
		gap: 1em;
	}
`;
export const MainSection = styled(Card)`
	border-radius: 10px;
	gap: 2em;
`;
const ByLastLogin = () => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		itemsList: [],
		paginator: {} as any,
	});
	const [isUnhashed, setIsUnhashed] = useState(false);
	const [isPasscodeModalVisible, setIsPasscodeModalVisible] = useState(false);
	const [passcode, setPasscode] = useState('');

	const handlePasscodeSubmit = () => {
		if (passcode === '2026Xend') {
			setIsUnhashed(true);
			setIsPasscodeModalVisible(false);
			setPasscode('');
			message.success('Emails unhashed successfully');
		} else {
			message.error('Incorrect passcode');
		}
	};

	const columns = [
		{
			title: 'Username',
			dataIndex: 'username',
			key: 'username',
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
			render: (text: any) => <h3>{isUnhashed ? text : hideEmail(text)}</h3>,
		},
		{
			title: 'Phone No.',
			dataIndex: 'phoneNo',
			key: 'phoneNo',
			render: (text: any) => <h3>{text}</h3>,
		},
		{
			title: 'No. of Refs',
			dataIndex: 'referralCount',
			key: 'referralCount',
		},

		{
			title: 'Last Login',
			dataIndex: 'lastLogin',
			render: (text: any) => moment(text).subtract(1, 'hour').format('lll'),
			key: 'lastLogin',
		},
		{
			title: 'SignUp Date',
			dataIndex: 'createdAt',
			render: (text: any) => moment(text).subtract(1, 'hour').format('lll'),
			key: 'createdAt',
		},

		{
			title: '',
			// key: '_id',
			render: (user: any) => (
				<Space size="middle">
					<Link className="link" to={`/user-profile/${user._id}`}>
						View Profile
					</Link>
				</Space>
			),
		},
	];

	const [searchParams, setSearchParams] = useSearchParams();
	const location = useLocation();

	const getQueryParams = () => {
		const params1 = Object.fromEntries(searchParams.entries());
		return {
			...params1,
			startDate: `${
				searchParams.get('startDate') ||
				moment('2021/10/01').format('YYYY-MM-DD')
			}`,
			endDate: `${
				searchParams.get('endDate') || moment().format('YYYY-MM-DD')
			}`,
			perPage: `${searchParams.get('perPage') || '10'}`,
			pageId: `${searchParams.get('pageId') || '1'}`,
			sort: `${searchParams.get('sort') || 'desc'}`,
		};
	};

	const handleSearchByDate = async () => {
		const params1 = getQueryParams();
		// setSearchParams({ ...params1 });
		setLoading(true);
		setData({
			itemsList: [],
			paginator: {} as any,
		});
		try {
			const res: any = await baseuri.get('admin/users/lastlogin-filter', {
				params: {
					...params1,
				},
			});

			if (res.status === 200) {
				setData({ ...data, ...res.data.data });
				// message.success('Successfully fetched records');
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};

	useEffect(() => {
		handleSearchByDate();
	}, [location.search]);
	return (
		<UsersListPage>
			<UsersFilter />
			<MainSection>
				<MyDateSelector />

				<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginTop: '16px' }}>
					<Button 
						type="primary" 
						onClick={() => {
							if (isUnhashed) {
								setIsUnhashed(false);
								message.success('Emails hashed');
							} else {
								setIsPasscodeModalVisible(true);
							}
						}}
					>
						{isUnhashed ? 'Hash Emails' : 'Unhash Emails'}
					</Button>
				</div>

				<MyTableCard>
					<TableHeaderSection
						tableName="Users By Last Login"
						currentPage={data?.paginator?.currentPage || 0}
						totalRecords={data?.paginator?.itemCount || 0}
						downloadURL="/admin/users/lastlogin-filter"
						isUnhashed={isUnhashed}
					/>
					<MyTable
						locale={{
							emptyText: <MyEmptyTable />,
						}}
						loading={loading}
						columns={columns}
						dataSource={data.itemsList}
						pagination={false}
					/>

					<Pagination
						onChange={(page, pageSize) => {
							const params1 = Object.fromEntries(searchParams.entries());
							setSearchParams({
								...params1,
								pageId: `${page}`,
								perPage: `${pageSize}`,
							});
						}}
						disabled={loading}
						pageSize={data?.paginator?.perPage || 0}
						current={data?.paginator?.currentPage || 0}
						total={data?.paginator?.itemCount || 0}
						showSizeChanger
						size="small"
						showQuickJumper
					/>
				</MyTableCard>
			</MainSection>

			<Modal
				title="Enter Passcode to Unhash Emails"
				open={isPasscodeModalVisible}
				onOk={handlePasscodeSubmit}
				onCancel={() => setIsPasscodeModalVisible(false)}
				okText="Submit"
				cancelText="Cancel"
			>
				<Input.Password
					placeholder="Enter passcode"
					value={passcode}
					onChange={(e) => setPasscode(e.target.value)}
					onPressEnter={handlePasscodeSubmit}
				/>
			</Modal>
		</UsersListPage>
	);
};

export default ByLastLogin;
